//----------------------------------------------------------------------------------------------------------------
// Copyright DeerSoft - 2019
//----------------------------------------------------------------------------------------------------------------

import React, { Component } from 'react';
import { Grid, Segment, Header, Icon, Button, Divider, Loader, Table, Card, Radio, Form, Container, Placeholder } from 'semantic-ui-react';
import LocalizedStrings from "../../localization/DownloadApp"
import { connect } from 'react-redux';
import { ACTIVE_USER } from '../../redux/redux_defines'
import { hasFetched } from '../../redux/actions/fetch_actions';
const ReactMarkdown = React.lazy(() => import("react-markdown"))

import gfm from 'remark-gfm';
import "./downloadApp.css";
const Nav = React.lazy(() => import("../ProductionAssistLandingPage/LandingPageNav"));

import fetch from 'cross-fetch';

const DOWNLOAD_OPTIONS = {
  DESKTOP: 0,
  VW: 1,
  MA: 2,
  AC: 3,
  BRX: 4,
  SKP: 5
}

//--------------------------------------------------------------------
// LightRightRouter
class DownloadApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      versionProduction: {},
      versionBeta: {},
      versions: [],
      checked: {
        windows: DOWNLOAD_OPTIONS.DESKTOP,
        apple: DOWNLOAD_OPTIONS.DESKTOP,
        linux: DOWNLOAD_OPTIONS.DESKTOP
      },
      activeCardIndex: -1,
    }
  }



  componentDidMount = async () => {
    await window.LR_ValidateToken()
    try {
      let response = await fetch("https://development.production-assist.com/api/update/latest");
      let json = await response.json()
      this.setState({ versionProduction: json })
    }
    catch (e) { console.error(e); }

    try {
      let response = await fetch("https://development.production-assist.com/api/update/latestbeta");
      let json = await response.json()

      this.setState({ versionBeta: json })

    }
    catch (e) { console.error(e); }

    try {
      let r1 = await fetch("https://development.production-assist.com/api/update/all");
      let j1 = await r1.json()
      this.setState({ versions: j1 })

    }
    catch (e) { console.error(e); }

  }

  loadReleaseChannel = async (version) => {
    if (!this.state[version]) {
      let response = await fetch("https://development.production-assist.com/api/update/" + version);
      let json = await response.json()
      this.setState({ [version]: json })
    }

  }



  render() {
    let isAdmin = false
    let isBeta = false
    if (hasFetched(this.props.loggedInUser)) {
      isAdmin = this.props.loggedInUser.data.isAdmin
      isBeta = this.props.loggedInUser.data.isBeta
    }

    return (
      <div className='download-app'>
        <header>
          <Nav />

          {/* <h2>{LocalizedStrings.HeaderRelease+ " " + this.state.versionProduction.version}</h2> */}

          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0, 0, 100, 38.5896"
          >
            <path
              width="100%"
              height="100%"
              d="M 100 38.5896 
                L 0 38.5896 
                L 78.9959 24.6768 
                C 91.3502 22.3542 100 12.1998 100 0 
                L 100 0 
                z"
            />
          </svg>
        </header>

        <div className='production'>
          {this.state.versionProduction.production ? (
            <>
              <h2 className='production-header'>
                <span className='production-header-span'>{LocalizedStrings.ProductionAssist}</span><br />
                <span className='header-version'>{LocalizedStrings.HeaderRelease + '' + this.state.versionProduction.version}</span><br />
                <span className='download-text'>{LocalizedStrings.Download}</span>
              </h2>

              <div className='flexContainer'>
                {this.renderDownloadStep("windows", this.state.versionProduction.production.winautocad, this.state.versionProduction.production.winbricscad22, this.state.versionProduction.production.winelectron, this.state.versionProduction.production.winvectorworks, this.state.versionProduction.production.winma3, "Production Assist for Windows", false)}
                {this.renderDownloadStep("apple",this.state.versionProduction.production.macautocad,this.state.versionProduction.production.macbricscad,  this.state.versionProduction.production.macelectron, this.state.versionProduction.production.macvectorworks, this.state.versionProduction.production.macma3, "Production Assist for macOS", false)}
                {this.renderDownloadStep("linux", undefined, undefined, this.state.versionProduction.production.linelectron, undefined, undefined, "Production Assist for Linux (Appimage)", false)}
              </div>

            </>
          ) : (
            <div className='flexContainer'>
            {this.renderLoading("windows", "Download Production Assist for Windows")}
            {this.renderLoading("apple", "Download Production Assist for macOS")}
            {this.renderLoading("linux", "Download Production Assist for Linux (Appimage)")}
          </div>
          )}
        </div>
        <Container>
        <ReactMarkdown remarkPlugins={[gfm]}>{this.state.versionProduction.changelog}</ReactMarkdown>
        </Container>




        <Container>
          {this.state.versionBeta.beta && isBeta ?

            <Segment className='beta' tertiary>
              <Header as="h1" textAlign="center">{LocalizedStrings.HeaderBeta + " " + this.state.versionBeta.version}</Header>
              <Divider />
              <ReactMarkdown remarkPlugins={[gfm]}>{this.state.versionBeta.changelog}</ReactMarkdown>
              <Divider />
              {this.renderDownloadStepBeta(this.state.versionBeta.beta.macelectron, this.state.versionBeta.beta.winelectron, this.state.versionBeta.beta.linelectron, "Desktop App" /*beta*/, true)}
              {this.renderDownloadStepBeta(this.state.versionBeta.beta.macvectorworks, this.state.versionBeta.beta.winvectorworks, undefined, "Production Assist for Vectorworks" /*beta*/, true)}
              {this.renderDownloadStepBeta(undefined, undefined, undefined, "Production Assist for grandMA3" /*beta*/, true)}
              {this.renderDownloadStepBeta(this.state.versionBeta.beta.macautocad, this.state.versionBeta.beta.winautocad, undefined, "Production Assist for AutoCAD" /*beta*/, true)}
              {this.renderDownloadStepBeta(this.state.versionBeta.beta.macbricscad, this.state.versionBeta.beta.winbricscad22, undefined, "Production Assist for BricsCAD" /*beta*/, true)}
            </Segment> : null}



          {isAdmin ? this.state.versions.map(v => this.renderVersion(v.version)) : null}
        </Container>
      </div>
    );
  }

  renderVersion(versionnumber) {
    let open = this.state[versionnumber + "OPEN"]
    return (
      <Segment tertiary key={versionnumber}>
        <Header as="h1" textAlign="center"><Icon onClick={() => { this.loadReleaseChannel(versionnumber); this.setState({ [versionnumber + "OPEN"]: !open }) }} name={this.state[versionnumber + "OPEN"] ? "angle down" : "angle right"} />{LocalizedStrings.HeaderChannel + " " + versionnumber}</Header>
        {open ? <Divider /> : null}
        <Table celled striped>
          <Table.Body>
            {open ? this.state[versionnumber] ? this.state[versionnumber].updates.map(entry => { return this.renderBin(entry) }) : <Loader /> : null}
          </Table.Body>
        </Table>
      </Segment>)
  }

  renderBin(entry) {
    const date = new Date(Date.parse(entry.date))

    const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: "2-digit", minute: "2-digit" };
    return (<Table.Row key={entry._id}>

      <Table.Cell collapsing>
        <Icon name='folder' /> {entry.buildnumber}
      </Table.Cell>
      <Table.Cell>{entry.channel}</Table.Cell>
      <Table.Cell>{entry.type}</Table.Cell>
      <Table.Cell collapsing textAlign='right'>
        {date.toLocaleDateString(undefined, options)}
      </Table.Cell>
      <Table.Cell collapsing textAlign='right'>
        <Button onClick={() => { this.download(entry._id) }} primary><Icon name="download" />{LocalizedStrings.Download}</Button>
      </Table.Cell>
    </Table.Row>)
  }

  renderDownloadStep(iconName, autocad, bricscad, electron, vector, ma3, entry, showBuildNumber) {
    const getId = (obj) => obj ? obj._id : ""

    const onChange = (checked) => () =>
      this.setState({
        checked: {
          ...this.state.checked,
          [iconName]: checked
        }
      })

    let selected = this.state.checked[iconName]
    let id = ""
    switch (selected) {
      case DOWNLOAD_OPTIONS.DESKTOP: id = getId(electron); break;
      case DOWNLOAD_OPTIONS.VW: id = getId(vector); break;
      case DOWNLOAD_OPTIONS.MA: id = getId(ma3); break;
      case DOWNLOAD_OPTIONS.AC: id = getId(autocad); break;
      case DOWNLOAD_OPTIONS.BRX: id = getId(bricscad); break;
      case DOWNLOAD_OPTIONS.SKP: id = getId(bricscad); break;
      default:
        break;
    }

    return (
      <Card className='card'>

        <div className='callout'>
          <div className='callout-inner'>
            <Icon name={iconName} style={{ fontSize: "3.5rem", color: "#5711f0" }} />
          </div>
        </div>

        <h3>{entry}</h3>

        <div className='radioContainer'>
          <Form>
            <Form.Field>
              <Radio
                label={<label style={{ fontWeight: 'bold', fontSize: '16px' }}>{LocalizedStrings.DesktopRadio}</label>}
                name='radioGroup'
                checked={selected === DOWNLOAD_OPTIONS.DESKTOP}
                onChange={onChange(DOWNLOAD_OPTIONS.DESKTOP)}
              />
            </Form.Field>
            {
              iconName !== "linux" ?
                <Form.Field>
                  <Radio
                      label={<label style={{ fontWeight: 'bold', fontSize: '16px' }}>{LocalizedStrings.VectorworkRadio}</label>}
                    name='radioGroup'
                    checked={selected === DOWNLOAD_OPTIONS.VW}
                    onChange={onChange(DOWNLOAD_OPTIONS.VW)}
                  />
                </Form.Field>
                : null
            }
            {
              iconName !== "linux" ?
                <Form.Field>
                  <Radio
                   label={<label style={{ fontWeight: 'bolder', fontSize: '16px' }}>{LocalizedStrings.GrandMA3Radio}</label>}
                    name='radioGroup'
                    checked={selected === DOWNLOAD_OPTIONS.MA}
                    onChange={onChange(DOWNLOAD_OPTIONS.MA)}
                  />
                </Form.Field>
                : null
            }
            {
              iconName !== "linux" ?
                <Form.Field>
                  <Radio
                   label={<label style={{ fontWeight: 'bolder', fontSize: '16px' }}>{LocalizedStrings.AutoCAD}</label>}
                    name='radioGroup'
                    checked={selected === DOWNLOAD_OPTIONS.AC}
                    onChange={onChange(DOWNLOAD_OPTIONS.AC)}
                  />
                </Form.Field>
                : null
            }
            {
              iconName !== "linux" ?
                <Form.Field>
                  <Radio
                   label={<label style={{ fontWeight: 'bolder', fontSize: '16px' }}>{LocalizedStrings.BricsCAD}</label>}
                    name='radioGroup'
                    checked={selected === DOWNLOAD_OPTIONS.BRX}
                    onChange={onChange(DOWNLOAD_OPTIONS.BRX)}
                  />
                </Form.Field>
                : null
            }
            {
              iconName !== "linux" ?
                <Form.Field>
                  <Radio
                   label={<label style={{ fontWeight: 'bolder', fontSize: '16px' }}>{LocalizedStrings.SketchUp}</label>}
                    name='radioGroup'
                    checked={selected === DOWNLOAD_OPTIONS.SKP}
                    onChange={onChange(DOWNLOAD_OPTIONS.SKP)}
                  />
                </Form.Field>
                : null
            }
          </Form>
        </div>

        <Button
          size='big'
          color='pink'
          onClick={() => {
            this.download(id);
          }}
         
        >
          <Icon name='download' />
          {LocalizedStrings.Download}
        </Button>



      </Card>
    )
  }

  renderDownloadStepBeta(mac, win, lin, entry, showBuildNumber) {
    return (
      <Grid textAlign='center' columns={3} >
        <Grid.Row>
          <Grid.Column size="3">
            <Segment placeholder>
              <Header icon>
                <Icon name='windows' />
                {entry}
                <br />
                {LocalizedStrings.Windows}
                {showBuildNumber ? win ? <><br />{win.buildnumber}<br /></> : <><i>{LocalizedStrings.NoReleaseFound}</i><br /></> : null}

                {(win && showBuildNumber) ? new Date(win.date).toDateString() : null}
              </Header>
              <Button onClick={() => { this.download(win._id) }} primary disabled={!win}><Icon name="download" />{LocalizedStrings.Download}</Button>
              {this.renderCopyLink(win?._id)}
            </Segment>
          </Grid.Column >
          <Grid.Column size="3">
            <Segment placeholder>
              <Header icon>
                <Icon name='apple' />
                {entry}
                <br />
                {LocalizedStrings.Mac}
                {showBuildNumber ? mac ? <><br />{mac.buildnumber}<br /></> : <><i>{LocalizedStrings.NoReleaseFound}</i><br /></> : null}
                <br />
                {(mac && showBuildNumber) ? new Date(mac.date).toDateString() : null}
              </Header>
              <Button onClick={() => { this.download(mac._id) }} disabled={!mac} primary><Icon name="download" />{LocalizedStrings.Download} </Button>
              {this.renderCopyLink(mac?._id)}
            </Segment>
          </Grid.Column >
          <Grid.Column size="3">
            <Segment placeholder>
              <Header icon>
                <Icon name='linux' />
                {entry}
                <br />
                {LocalizedStrings.Ubunto}
                {showBuildNumber ? lin ? <><br />{lin.buildnumber}<br /></> : <><i>{LocalizedStrings.NoReleaseFound}</i><br /></> : null}
                {(lin && showBuildNumber) ? new Date(lin.date).toDateString() : null}
              </Header>
              <Button onClick={() => { this.download(lin._id) }} disabled={!lin} primary ><Icon name="download" />{LocalizedStrings.Download} </Button>
              {this.renderCopyLink(lin?._id)}
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }

  renderCopyLink(id) {
    return <>
      <Button onClick={() => {
        navigator.clipboard.writeText(`https://development.production-assist.com/api/update/download/${id}`);
      }}><Icon name="copy" /></Button>

    </>
  }

  download = async (id) => {
    let url = "https://development.production-assist.com/api/update/download/" + id

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      "",
    );

    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }

  renderLoading = (iconName, entry) => {
    return (
      <Card className='card'>
        <div className='callout'>
          <div className='callout-inner'>
            <Icon name={iconName} style={{ fontSize: "3.5rem", color: "#353c94" }} />
          </div>
        </div>
        <h3>{entry}</h3>
        <div style={{ margin: "0 0 5rem 5rem" }}>
          <Placeholder fluid color="gray">
            <Placeholder.Line length='medium' />
            <Placeholder.Line length='medium' />
            <Placeholder.Line length='medium' />
          </Placeholder>
        </div>
        <Button size='small' color='pink'><Icon name="download" />{LocalizedStrings.Download}</Button>
      </Card>
    )
  }
}

//---------------------------------------------------------------------
// Redux Connection
const mapStateToProps = (state) => {
  return {
    loggedInUser: (state[ACTIVE_USER]),
  };
}

export default connect(mapStateToProps)(DownloadApp)


